import React from "react"
import { graphql, Link } from "gatsby"
import { FaArrowRight } from "react-icons/fa"
import { HeroBlock } from "./_HeroBlock"
import { TextBlock } from "./_TextBlock"
import { ProductPreviewBlock } from "./_ProductPreviewBlock"
import { Section } from "../components"

export const Blocks = ({ blocks }: BlocksProps) => (
  <>
    {blocks.map(block => {
      switch (block.__typename) {
        case "SanityHero": {
          return (
            <Section key={block.__typename} width="large">
              <HeroBlock {...block} />
            </Section>
          )
        }
        case "SanityWysiwyg": {
          return (
            <Section width="medium">
              <TextBlock {...block} />
            </Section>
          )
        }
        case "SanityProductPreview": {
          return (
            <>
              <Section width="large">
                <ProductPreviewBlock {...block} maxAmount={6} />
              </Section>
              <Section width="large">
                <Link
                  to="/products/1"
                  className="flex items-center gap-3 text-sm font-medium text-gray-900 underline underline-offset-2 antialiased hover:translate-x-[2px] hover:gap-4 hover:underline md:text-base"
                >
                  View all products
                  <FaArrowRight color="#111827" />
                </Link>
              </Section>
            </>
          )
        }
        default:
          return null
      }
    })}
  </>
)

export type BlocksProps = {
  blocks: any[]
}

export const BlocksFragments = graphql`
  fragment PageBlocks on SanityPage {
    blocks {
      __typename
      ...HeroFields
      ...TextFields
    }
  }
`
